import { createContext, useEffect, useState } from 'react';

export const WindowSizeContext = createContext({
    width: window.innerWidth,
    height: window.innerHeight
});

export const WindowSizeProvider = ({ children }) => {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return <WindowSizeContext.Provider value={windowSize}>{children}</WindowSizeContext.Provider>;
};
